<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>New Name</mat-label>
      <input matInput name="newName" [(ngModel)]="data.name" />
    </mat-form-field>
  </form>
  <app-share-editor
    *ngIf="data.isOwner"
    allowReadOnly="true"
    allowModify="true"
    [(ngModel)]="data.shareState"
    [avaialbleSubscriptions]="data.userSubscriptions"
  ></app-share-editor>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
